import ModalContainer, {
  ModelContainerProps,
} from "../../../../../shared/oversight-core/ui-elements/modal-container/modal-container";

interface IProps extends ModelContainerProps {
  idTag?: string;
}

const RemoveRfidModal = (props: IProps) => {
  const { idTag, onConfirm, isLoading, ...rest } = props;

  return (
    <ModalContainer
      {...rest}
      title="Remove RFID"
      confirmButtonText="Remove"
      confirmButtonVariant="red"
      size="modal-md"
      onConfirm={onConfirm}
      isLoading={isLoading}
    >
      <p className="text-light font-size-14 m-0">
        Are you sure you want to remove RFID tag{" "}
        {idTag ? <strong>{idTag}</strong> : "this RFID tag"}?
      </p>
    </ModalContainer>
  );
};

export default RemoveRfidModal;
